import ActionType from 'actions/ActionType'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.Inbox.SELECT_CONVERSATION:
      return null
    case ActionType.Inbox.CONTACT_SEARCH:
      return action.payload
    case ActionType.Inbox.SEND_SMS:
      if (action.payload && action.payload.contactSelected) {
        return null
      }
      return state
    case ActionType.Email.SEND_REQUEST:
      if (action.extraData && action.extraData.contactSelected) {
        return null
      }
      return state
    default:
      return state
  }
}
